import { ValidationProps } from 'ui';
import { CodeDescriptionSearchData, ModifiedCodeDescription } from './types-store';

export const removeValidationForCodeDescription = (
  validation: { [key: string]: ValidationProps },
  modifiedCodeData: ModifiedCodeDescription,
  previousCodeData: ModifiedCodeDescription
): { [key: string]: ValidationProps } => {

  const removeKeys = [
    ...(modifiedCodeData?.description !== previousCodeData?.description ? ['description'] : []),
    ...(modifiedCodeData?.longDescription !== previousCodeData?.longDescription ? ['longDescription'] : [])
  ];

  return Object.keys(validation || {})
    .reduce((result, key) => {

      if (!removeKeys.includes(key)) {
        return {
          ...result,
          [key]: validation[key]
        };
      }

      const messages = validation[key].messages?.filter(message =>
        message.parameters?.id !== modifiedCodeData?.id ||
        message.parameters?.language !== modifiedCodeData?.language ||
        message.parameters?.codetable !== modifiedCodeData?.codetable);

      return messages?.length ?? 0 > 0
        ? {
          ...result,
          [key]: {
            ...validation[key],
            messages
          }
        }
        : result;
    }, {} as { [key: string]: ValidationProps });
};

export const getComponentValidation = (
  validation: { [key: string]: ValidationProps },
  codeData: CodeDescriptionSearchData
): { [key: string]: ValidationProps } => {
  return Object.keys(validation || {})
    .reduce((result, key) => {
      const messages = validation[key].messages?.filter(message =>
        message.parameters?.id === codeData?.id &&
        message.parameters?.language === codeData?.language?.v &&
        message.parameters?.codetable === codeData?.codetable?.v
      );

      return messages?.length ?? 0 > 0
        ? {
          ...result,
          [key]: {
            ...validation[key],
            messages
          }
        }
        : result;
    }, {} as { [key: string]: ValidationProps });
};
